import { render, staticRenderFns } from "./AddChangelogModal.vue?vue&type=template&id=7590f8d2&scoped=true&"
import script from "./AddChangelogModal.vue?vue&type=script&lang=js&"
export * from "./AddChangelogModal.vue?vue&type=script&lang=js&"
import style0 from "./AddChangelogModal.vue?vue&type=style&index=0&id=7590f8d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590f8d2",
  null
  
)

export default component.exports